// Browser page translation (Chrome, the Google app, Safari) replaces the text
// nodes React rendered with <font> wrappers. React keeps references to the
// originals, so its next removeChild/insertBefore targets a node that is no
// longer a child, the DOM throws NotFoundError mid-commit, and the whole React
// root unmounts. React has no fix: https://github.com/facebook/react/issues/11538
// Noibu: #103552 (WebKit), #168247 / #168251 (Chromium).
export const guardTranslatedDomMutations = (): (() => void) => {
  const { removeChild, insertBefore } = Node.prototype;

  Node.prototype.removeChild = function guardedRemoveChild<T extends Node>(
    this: Node,
    child: T
  ): T {
    if (child.parentNode !== this) {
      console.warn(
        'Skipped removeChild of a node that is no longer a child (likely page translation)'
      );
      return child;
    }
    return removeChild.call(this, child) as T;
  };

  Node.prototype.insertBefore = function guardedInsertBefore<T extends Node>(
    this: Node,
    node: T,
    referenceNode: Node | null
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn(
        'Appended node whose insertBefore reference is no longer a child (likely page translation)'
      );
      // Appending keeps new content (prices, errors, spinners) on screen;
      // only its position within the parent can be off.
      return insertBefore.call(this, node, null) as T;
    }
    return insertBefore.call(this, node, referenceNode) as T;
  };

  return () => {
    Node.prototype.removeChild = removeChild;
    Node.prototype.insertBefore = insertBefore;
  };
};
